/**
 * Contract list data hook - fetch organization deal reports
 */
import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'

import {
  listOrganizationDealPerFrame,
  listOrganizationDealReports,
} from '@enechain/eposition-proto/bffportal/v1/report_service-ReportService_connectquery'
import {
  ListOrganizationDealPerFrameRequestSchema,
  type ListOrganizationDealPerFrameResponse,
  ListOrganizationDealReportsRequestSchema,
} from '@enechain/eposition-proto/bffportal/v1/report_service_pb'
import { convertGoogleDateModel } from '@enechain/eposition-ui/src/models/date'

import { ContractListFilterState } from '~/pages/ContractList/hooks/useContractListFilter'

import {
  type ContractDealReportModel,
  convertContractDealReportModels,
} from '../models/contractDealReport'

type Result = {
  data: ContractDealReportModel[]
  perFrameData: ListOrganizationDealPerFrameResponse | undefined
  isLoading: boolean
  isPerFrameLoading: boolean
}

export function useContractListData(filter: ContractListFilterState): Result {
  const { data, isLoading } = useQuery(
    listOrganizationDealReports,
    create(ListOrganizationDealReportsRequestSchema, {
      excludeSettled: filter.excludeSettled,
      fromDate:
        filter.fromDate != null
          ? convertGoogleDateModel(filter.fromDate)
          : undefined,
      toDate:
        filter.toDate != null
          ? convertGoogleDateModel(filter.toDate)
          : undefined,
      splitByMonth: false,
    }),
  )

  const { data: perFrameData, isLoading: isPerFrameLoading } = useQuery(
    listOrganizationDealPerFrame,
    create(ListOrganizationDealPerFrameRequestSchema, {
      excludeSettled: filter.excludeSettled ?? false,
      fromDate:
        filter.fromDate != null
          ? convertGoogleDateModel(filter.fromDate)
          : undefined,
      toDate:
        filter.toDate != null
          ? convertGoogleDateModel(filter.toDate)
          : undefined,
    }),
  )

  const modelData =
    data != null ? convertContractDealReportModels(data.dealReports) : []

  return {
    data: modelData,
    perFrameData,
    isLoading,
    isPerFrameLoading,
  }
}
